import styled from 'styled-components';
import { Descriptions } from 'antd';

export const StyledDescriptions = styled(Descriptions)`
  .ant-descriptions-item {
    padding-bottom: 0;
  }
`;
